import { combineReducers } from 'redux';
import auth from './auth';
import currencies from './currencies';
import distribution from './distribution';
import journals from './journals';
import primeur from './primeur';
import wines from './wines';
import positions from './positions';
import notes from './notes';
import journalists from './journalists';
import campaigns from './campaigns';
import services from './services';
import negoce from './negoce';
import prices from './prices';
import onlineSales from './onlineSales';
import dashboard from './dashboard';
import currentPageFeeds from './currentPageFeeds';
import { i18nReducer as i18n } from 'react-redux-i18n';
import auction from './auction';
import brands from './brands';

const rootReducer = combineReducers({
  auth,
  auction,
  brands,
  currencies,
  positions,
  distribution,
  journals,
  primeur,
  wines,
  notes,
  journalists,
  services,
  negoce,
  campaigns,
  prices,
  onlineSales,
  dashboard,
  currentPageFeeds,
  i18n
});

export default rootReducer;
